import { Grid, Typography } from "@mui/material";
import AddBranchForm from "../../../Components/Organisms/Branches/AddBranchForm.jsx";

const EditBranchTemplate = (props) => {
  const {
    t,
    type,
    editBranch,
    uploadImages,
    organizationsList,
    createBranch,
    branchImages,
    RemoveBranchImage,
    uploadLocalLicense,
    uploadLicense,
    localeLicenseImg,
    licenseImg,
    getFeaturesOptions,
    featureOptions,
    supportedLanguages,
    branchDetails,
    formType,
    getOrganization,
    organizationsCount,
    RemoveLocaleLicenseImg,
    licensesData,
    getbranchDetails,
    id
  } = props;

  return (
    <Grid container>
      <Grid container>
        <AddBranchForm
          getOrganization={getOrganization}
          organizationsCount={organizationsCount}
          branchDetails={branchDetails}
          uploadImages={uploadImages}
          editBranch={editBranch}
          organizationsList={organizationsList}
          createBranch={createBranch}
          branchImages={branchImages}
          RemoveBranchImage={RemoveBranchImage}
          uploadLocalLicense={uploadLocalLicense}
          uploadLicense={uploadLicense}
          localeLicenseImg={localeLicenseImg}
          licenseImg={licenseImg}
          getFeaturesOptions={getFeaturesOptions}
          featureOptions={featureOptions}
          supportedLanguages={supportedLanguages}
          type={type}
          formType={formType}
          RemoveLocaleLicenseImg={RemoveLocaleLicenseImg}
          licensesData={licensesData}
          getbranchDetails={getbranchDetails}
          id={id}
        />
      </Grid>
    </Grid>
  );
};

export default EditBranchTemplate;
